import { BaseCollection } from './base-collection.model';
import { BasicUser } from './user.model';

export interface SipConfig {
  id: number;
  enabled: boolean;
  createdAt: Date | string;
  updatedAt: Date | string | null;
  name: string;
  host: string;
  port: number;
  protocol: string;
  prefix: string | null;
  userId: number;
  user?: BasicUser;
  mainaccountId: number;
  online: boolean;
  batch: boolean;
  selected: boolean;
  cps: number;
  username: string | null;
  pingEnabled: boolean;
}

export interface SipConfigCollection extends BaseCollection {
  content: SipConfig[];
}

export interface SipConfigUpdate {
  id: number;
  enabled: boolean;
  pingEnabled: boolean;
  name: string;
  host: string;
  port: number;
  protocol: string;
  prefix: string | null;
  cps: number;
  username: string;
  password: string;
}

export interface SipConfigImportRow {
  rowNumber: number;
  name: string;
  host: string;
  port: number | null;
  prefix: string | null;
  username: string | null;
  password: string | null;
  pingEnabled: boolean | null;
}

export interface SipConfigImportError {
  rowNumber: number;
  name?: string;
  messages: string[];
}

export interface SipConfigImportResult {
  created: number;
  failed: number;
  errors: SipConfigImportError[];
}

export function sipConfigToUpdate(config: SipConfig): SipConfigUpdate {
  return {
    id: config.id,
    enabled: config.enabled,
    pingEnabled: config.pingEnabled,
    name: config.name,
    host: config.host,
    port: config.port,
    protocol: config.protocol,
    prefix: config.prefix,
    cps: config.cps,
    username: config.username,
    password: null,
  };
}
